(function($, Drupal, drupalSettings) {

  "use strict";
  Drupal.behaviors.treston_gallery = {
    attach: function(context, settings) {
      // Gallery
      Drupal.behaviors.treston_gallery.activateGalleries(context);
    },
    activateGalleries: function (context){
      galleryvar = [];
      if (context.querySelectorAll('.paragraph--type--image-video-gallery .gallery-inner, .gallery-container .gallery-inner').length > 0) {
        var galleryvar = context.querySelectorAll('.paragraph--type--image-video-gallery .gallery-inner, .gallery-container .gallery-inner');
      } else {
        var galleryvar = context.querySelectorAll('#block-story-gallery .gallery-inner');
      }

      galleryvar.forEach( function(gallery) {
        var $gallery = $(gallery),
            $innerGallery = $( gallery.querySelector('.gallery') );
          var galleryLoadReady = function() {
            if( $gallery.parent().find('.scroll').length === 0 && gallery.clientWidth != $innerGallery[0].scrollWidth ){
              var parent = gallery;
              var child = $innerGallery[0];
              child.style.paddingBottom = child.offsetHeight - child.clientHeight + "px";
              $gallery.parent()
                .append( '<span class="scroll right" data-dir="right"></span>')
                .prepend('<span class="scroll left" data-dir="left"></span>');

              $('.scroll',$gallery.parent()).each(function(i,scrlbtn){
                scrlbtn.addEventListener('click',function(e){
                  var gLeft  = $gallery.offset().left;
                  var gWidth = $gallery.width();
                  var dir    = this.dataset.dir;
                  var movement = 0;

                  $gallery.find('li').not('[class]').each( function(i,img) {
                    var imgmovement = $(img).offset().left-gLeft;
                    if( dir == 'left' ){
                      if( (movement == 0 || movement < 0) && imgmovement < 0 ){
                        movement = imgmovement - 1 ;
                      }
                    }else{
                      if( movement == 0 ){
                        imgmovement = imgmovement+$(img).width();
                        if( imgmovement > gWidth ){
                          movement = imgmovement - gWidth+1;
                        }
                      }
                    }
                  });

                  $innerGallery.animate({
                    scrollLeft: '+='+(movement)
                  },150);

                })
              });
            }
          };


          $innerGallery.imagesLoaded().always( function() {

            var $gallerImages = $innerGallery.find('img');

            // Callback function to execute when mutations are observed
            var callback = function(mutationsList) {
              var remainingCount = 0;
              $gallerImages.each( function( index, item ) {
                var itemClassList = item.classList;
                if( itemClassList.contains('lazyload') || itemClassList.contains('lazyloading') ){
                  remainingCount++;
                }
              });
              if( remainingCount == 0 ){
                observer.disconnect();
              }
              galleryLoadReady();
            };
            // Create an observer instance linked to the callback function
            var observer = new MutationObserver(callback);

            $gallerImages.each( function( index, item ) {
              var itemClassList = item.classList;
              if( itemClassList.contains('lazyload') || itemClassList.contains('lazyloading') ){
                // Start observing the target node for configured mutations
                observer.observe(item, { attributes: true });
              }
            });
            galleryLoadReady();
          });
      });
    }
  }

})(jQuery, Drupal, drupalSettings);
